/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Who put this stream in the list — TOURNAMENT = admin/organiser-managed; PARTICIPANT = a competitor toggling their own connected channel. Drives streamingMode filtering.
 * @export
 */
export const FeaturedStreamSource = {
    TOURNAMENT: 'TOURNAMENT',
    PARTICIPANT: 'PARTICIPANT'
} as const;
export type FeaturedStreamSource = typeof FeaturedStreamSource[keyof typeof FeaturedStreamSource];


export function instanceOfFeaturedStreamSource(value: any): boolean {
    for (const key in FeaturedStreamSource) {
        if (Object.prototype.hasOwnProperty.call(FeaturedStreamSource, key)) {
            if (FeaturedStreamSource[key as keyof typeof FeaturedStreamSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FeaturedStreamSourceFromJSON(json: any): FeaturedStreamSource {
    return FeaturedStreamSourceFromJSONTyped(json, false);
}

export function FeaturedStreamSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeaturedStreamSource {
    return json as FeaturedStreamSource;
}

export function FeaturedStreamSourceToJSON(value?: FeaturedStreamSource | null): any {
    return value as any;
}

export function FeaturedStreamSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): FeaturedStreamSource {
    return value as FeaturedStreamSource;
}

